import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import PMBBadge from 'components/PMBBadge'
import useIsMobile from 'hooks/useIsMobile'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Container, Spinner } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const PMBTotalFooter = ({
  total,
  isDisable,
  onSubmit,
  textBtn,
  customButton,
  customTotalText,
  buttonOnly,
  noMinimum,
  customStyle,
  oldTotal,
  isLoading = false,
  isAdjustBySeller,
  onSubmitDraft,
  isLoadingSetDraft,
  countChecked,
  countTotal,
  body,
  testId = 'pmb-total-footer',
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const { isOpenNavbar } = useSelector((s) => s.dashboard)
  const isTabletOrDesktop = screenWidth >= 768
  const isMobile = useIsMobile()

  const safeTotal = isNaN(Number(total)) ? 0 : Number(total)
  const safeOldTotal = isNaN(Number(oldTotal)) ? 0 : Number(oldTotal)

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div
      className="border-top border-2"
      style={
        customStyle
          ? { ...customStyle }
          : {
              backgroundColor: 'white',
              position: 'fixed',
              bottom: 0,
              width: isTabletOrDesktop
                ? `calc(100% - ${isOpenNavbar ? '280px' : '80px'})`
                : '100%',
              zIndex: 20,
              padding: isMobile ? '10px 12px' : '16px 20px',
            }
      }
    >
      <Container className="custom-container m-auto">
        {body ? (
          body
        ) : isMobile ? (
          <div className="d-flex flex-column" style={{ gap: '8px' }}>
            {!buttonOnly && (
              <>
                {onSubmitDraft && (
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{ gap: '6px' }}
                  >
                    <div
                      data-testid={`${testId}-checked-count`}
                      style={{
                        padding: '4px 10px',
                        borderRadius: '6px',
                        background:
                          countChecked === countTotal ? '#dcfce7' : '#fef2f2',
                        border: `1px solid ${countChecked === countTotal ? '#86efac' : '#fecaca'}`,
                        fontSize: '11px',
                        fontWeight: 600,
                        color:
                          countChecked === countTotal ? '#047857' : '#dc2626',
                      }}
                    >
                      {countChecked}/{countTotal} sudah dicek
                    </div>

                    <CustomButton
                      block
                      outline
                      color="primary"
                      testId={`${testId}-draft`}
                      style={{
                        padding: '8px 12px',
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                      onClick={onSubmitDraft}
                      disabled={isLoadingSetDraft}
                    >
                      Simpan sebagai draft
                    </CustomButton>
                  </div>
                )}
                {customTotalText ? (
                  customTotalText
                ) : (
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#374151',
                      }}
                    >
                      {isAdjustBySeller
                        ? 'Jumlah yang diterima:'
                        : 'Total yang dibayar:'}
                    </span>
                    <div className="text-end">
                      {safeTotal > 0 && safeTotal < 50000 && !noMinimum && (
                        <div
                          style={{
                            fontSize: '10px',
                            color: '#dc2626',
                            marginBottom: '2px',
                          }}
                        >
                          (Minimal Rp50.000)
                        </div>
                      )}
                      <div
                        style={{
                          fontSize: '15px',
                          fontWeight: 700,
                          color: '#006386',
                        }}
                      >
                        Rp
                        {newFormatThousandSeparator(safeTotal, 0)}
                      </div>
                      {safeOldTotal ? (
                        <div
                          style={{
                            fontSize: '11px',
                            color: '#dc2626',
                            marginTop: '2px',
                          }}
                        >
                          (Rp
                          {newFormatThousandSeparator(
                            safeOldTotal,
                            0,
                          )}
                          )
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}
              </>
            )}
            {customButton ? (
              customButton
            ) : (
              <CustomButton
                block
                color="primary"
                testId={`${testId}-submit`}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  fontWeight: 600,
                }}
                onClick={onSubmit}
                disabled={isDisable || isLoading}
              >
                {isLoading && <Spinner size="sm" className="me-2" />}
                {textBtn ? textBtn : 'Buat Transaksi'}
              </CustomButton>
            )}
          </div>
        ) : (
          <div className="flex-centered justify-content-between">
            {customTotalText ? (
              customTotalText
            ) : (
              <div div style={{ visibility: buttonOnly ? 'hidden' : '' }}>
                <div>
                  {safeTotal > 0 && safeTotal < 50000 && !noMinimum && (
                    <span className="text-sm text-danger">
                      (Minimal Rp50.000)
                    </span>
                  )}
                </div>
                <div className="d-flex">
                  <P className="fw-semibold">
                    {isAdjustBySeller
                      ? 'Jumlah yang diterima:'
                      : 'Total yang dibayar:'}{' '}
                  </P>
                  <div>
                    <P
                      className="text-primary fw-bold mx-1"
                      style={{ fontSize: '18px' }}
                    >
                      Rp
                      {newFormatThousandSeparator(safeTotal, 0)}
                    </P>
                    {safeOldTotal ? (
                      <P className={'mx-1'} color={'#d92d20'}>
                        {`(Rp
                    ${newFormatThousandSeparator(
                      safeOldTotal,
                      0,
                    )})`}
                      </P>
                    ) : null}
                  </div>
                </div>
              </div>
            )}

            <div className="d-flex flex-column align-items-center gap-2">
              {onSubmitDraft && (
                <PMBBadge
                  title={`${countChecked}/${countTotal} sudah dicek`}
                  variant={countChecked === countTotal ? 'verify' : 'danger'}
                />
              )}

              <div className="d-flex gap-2">
                {customButton ? (
                  customButton
                ) : (
                  <CustomButton
                    size="sm"
                    color="primary"
                    className="p-2"
                    testId={`${testId}-submit`}
                    onClick={onSubmit}
                    disabled={isDisable || isLoading}
                  >
                    {isLoading && <Spinner size="sm" className="me-2" />}
                    {textBtn ? textBtn : 'Buat Transaksi'}
                  </CustomButton>
                )}

                {onSubmitDraft && (
                  <CustomButton
                    size="sm"
                    outline
                    color="primary"
                    className="p-2"
                    testId={`${testId}-draft`}
                    onClick={onSubmitDraft}
                    disabled={isLoadingSetDraft}
                  >
                    Simpan sebagai draft
                  </CustomButton>
                )}
              </div>
            </div>
          </div>
        )}
      </Container>
    </div>
  )
}

export default PMBTotalFooter
